import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { render } from 'react-dom';
import App from './App';
import './styles/settings.css';
import './styles/style.css';
import './styles/fonts/fontawesome-5/css/all.min.css';
import './styles/plugins/bootstrap-4.3.1/css/bootstrap.min.css';
import './index.css';
import { StyledEngineProvider } from '@mui/material/styles';
import './fonts/customIcon.css';

render(
  <StyledEngineProvider injectFirst>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StyledEngineProvider>,
  document.getElementById('root')
);
